import React from 'react'
import './sale.css'

export const BannerSale = () => {
  return (
    <div id='sale-banner' className=''>
        <img src="https://i.ibb.co/Rp32wnwk/Banner-Fenix-Ofertas-y-Descuentos-Moderno-Azul.png" alt="" srcset="" className='shadow'/>
    </div>
  )
}
